<template>
    <v-dialog
    v-model="dialogPayment"                
    width="500"
    persistent
    >        
        <v-card>
            <v-card-title
            class="white lighten-2 center"
            primary-title
            >
            <div v-if="!card">
                <img src="../assets/ok.png">
                <br> 
            </div>
                                                         
            </v-card-title>   
            <v-card-text>
                <div class="text-xs-center title white lighten-2">
                    {{this.dialogPaymentData.titulo}}                    
                </div>
            </v-card-text>
             <v-card-text class="text-xs-center" v-if="card">
                <span class="priceTag">{{this.dialogPaymentData.total.toFixed(2) + ' €'}}</span>
            </v-card-text>                          
            <v-card-text v-if="!card" class="text-xs-center dialogContent">
                {{this.dialogPaymentData.contenido}}
            </v-card-text>   
            <v-flex class="payDiv" xs12>
                <div id="card-form" :class="cardClase"></div>
            <input type="hidden" id="token" value=""/>
            <input type="hidden" id="errorCode" />
            <form
            id="authForm"
            @submit="checkForm"
            :action="acsURL"
            method="post"
            novalidate="true"
            >
            <input type="hidden" name="MD" :value="MD" />
            <input type="hidden" name="PaReq" :value="PaReq" />
            <input type="hidden" name="TermUrl" :value="TermUrl" />
            </form>
            <form
            id="authForm2"
            @submit="checkForm"
            :action="acsURL"
            method="post"
            novalidate="true"
            >
            <input type="hidden" name="creq" :value="creq" />
            </form>
            <form
            id="auth2xForm"
            @submit="checkForm"
            :action="auth2xurl"
            method="post"
            novalidate="true"
            >
            <input type="hidden" name="threeDSMethodData" :value="threeDSMethodData" />
            </form>
            <v-card-text class="text-xs-center dialogContent">
                <v-checkbox
                    v-if="card"
                    v-model="save"
                    :label="`Guardar referencia de pago para futuras compras`"
                    :messages="`La referencia de su pago se almacena en servidores seguros de la entidad. Fiehisa no almacenará ningún dato sensible`"
                ></v-checkbox>
            </v-card-text> 
            <!--form method="post" action="https://b2b.fiehisa.org/proxy">
            <button class="btn btn-default">Click to post</button>
            <input type="hidden" name="MD" value="asdasdasd" />
            </form-->
            <!--form :action="acsURL" method="post" name="authForm">
            <input type="hidden" name="MD" :value="MD" />
            <input type="hidden" name="PaReq" :value="PaReq" />
            <input type="hidden" name="TermUrl" :value="TermUrl" />
            <input id="subbutton" type="submit" value="Submit">
            </form-->
            </v-flex>                     
            <v-card-actions>
            
            <v-btn class="text-xs-center"
                color="primary"
                v-if="!card && !$store.state.usuario.pagoTarjetaObligatorio"
                flat
                :disabled="processing"
                @click="closeDialog()"
            >
                Finalizar pedido
            </v-btn>
            <v-btn class="text-xs-center"
                color="error"
                v-if="!card && $store.state.usuario.pagoTarjetaObligatorio"
                flat
                :disabled="processing"
                @click="cancelOrder()"
            >
                Cancelar Pedido
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn                
                color="success"
                v-if="!card && ($store.state.usuario.a != '') && ($store.state.usuario.oneclick)"
                flat                
                :disabled="processing"
                @click="oneclick()"
            >
                Pago 1 click
            </v-btn>
            <v-btn                
                color="success"
                v-if="!card && ($store.state.usuario.a == '')"
                flat    
                :disabled="processing"
                @click="checkCart()"
            >
                Pago con tarjeta
            </v-btn>
            <v-btn                
                color="success"
                v-if="!card && ($store.state.usuario.a != '')"
                flat    
                :disabled="processing"
                @click="checkCart()"
            >
                Pago con otra tarjeta
            </v-btn>
            <v-btn class="text-xs-center"            
                color="warning"
                v-if="card"
                flat      
                :disabled="processing"          
                @click="backFromPayment()"
            >
                Volver
            </v-btn>
            <v-btn                
                color="success"
                v-if="ok"
                flat      
                :disabled="processing"          
                @click="closeDialog()"
            >
                Volver
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'dialogPayment',
    data () {
      return {             
         card: false,
         cardClase: 'cardDivGone',
         ok: false,
         order: '',
         acsURL: "",
        MD: "",
        PaReq: "",
        creq: "",
        //TermUrl: "https://b2b.fiehisa.org/tpvAuth"
        TermUrl: "https://b2b.fiehisa.org/proxy",
    // usuario: ""
        auth2xurl: "",
        threeDSMethodData: "",
        save: true,
        processing: false,
        priceChange: false
      }
    },
    methods:{  
        oneclick(){
            
            var auxthis = this;
            var auxDoc = document;
            function pay(orderNo, amount, idOper) {     
                auxthis.$store.commit('setOneClick',auxthis.save);
                
                var url = "https://b2b.fiehisa.org/api/tpv/payment";
                
                auxthis.axios
                              
                    .post(url, {
                        custNo: auxthis.$store.state.usuario.custNo ,
                        idOper : idOper, 
                        orderNo : orderNo, 
                        navOrderNo: auxthis.dialogPaymentData.order, 
                        amount: amount,
                        save: auxthis.save,
                        user_guid: auxthis.$store.state.usuario.userGUID,
                        a: auxthis.$store.state.usuario.a
                    },{headers: {"Content-Type": "application/json"}}) //API
                    .then(response => {
                        if (response.data && !response.data.Ds_MerchantParameters && (response.data.responseType != 'auth2x') && ((response.data.substring(0,2) == 'ok') || (response.data.substring(0,2) == 'ko'))){
                            
                            auxthis.dialogPayment = false;
                            auxthis.card = false;
                            auxthis.cardClase = 'cardDivGone';
                            auxthis.$router.push({path: '/tpvAuth?res=' + response.data});
                        
                        } else {
                            if (response.data.responseType == 'auth2x'){
                                auxthis.threeDSMethodData = response.data.data;
                                auxthis.auth2xurl = response.data.authurl;
                                var f = auxDoc.getElementById("auth2xForm");//.submit();
                                setTimeout(function(){ 
                                    f.submit(); 
                                }, 500);
                            } else {
                                var decodedParmsString = atob(response.data.Ds_MerchantParameters);
                                //console.log(decodedParmsString);
                                var decodedParmsJson = JSON.parse(decodedParmsString);
                                //console.log(decodedParmsJson);
                                auxthis.acsURL = decodedParmsJson.Ds_EMV3DS.acsURL;
                                if (decodedParmsJson.Ds_EMV3DS.MD && !decodedParmsJson.Ds_EMV3DS.creq) {
                                    auxthis.MD = decodedParmsJson.Ds_EMV3DS.MD;
                                    auxthis.PaReq = decodedParmsJson.Ds_EMV3DS.PAReq;
                                    
                                    var f = auxDoc.getElementById("authForm");//.submit();
                                    setTimeout(function(){ 
                                        f.submit(); 
                                    }, 500);
                                } else {
                                    auxthis.creq = decodedParmsJson.Ds_EMV3DS.creq;
                                    
                                    var f = auxDoc.getElementById("authForm2");//.submit();
                                    setTimeout(function(){ 
                                        f.submit(); 
                                    }, 500);
                                }
                            }
                        }
                    })
                    .catch(function (error) {   
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        auxthis.processing = false;
                        
                    });
            };
            this.$fire({
                title: "Pago 1 click - " + parseFloat(auxthis.dialogPaymentData.total).toFixed(2) + '€',
                text: "Se utilizarán los datos de pago de su ultimo pedido pagado con tarjeta. ¿Desea continuar?",
                type: "confirm",
                showCancelButton: true,
                confirmButtonText: `Pagar`,
                cancelButtonText: `Volver`,
                allowOutsideClick: false,
                reverseButtons: true
            }).then(r => {
                //console.log(r);
                if (r.dismiss == 'cancel'){
                    //this.$router.push("menu");
                } else if (r.value){
                    auxthis.processing = true;
                    pay(Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 12),auxthis.dialogPaymentData.total,'');        
                }
            });
            //pay(this.order,10,"22150f4418fbc6b9bc69cc6088da39af1261b60d");

        },
        checkForm: function (e) {
            e.preventDefault();
        },         
        closeDialog(){
            this.sendOrderMail(this.dialogPaymentData.order);
            this.navigate(1);         
            this.dialogPayment = false;
        },
        backFromPayment(){
            this.card = false;
            this.cardClase = 'cardDivGone';
        },
        cancelOrder(){
            this.$fire({
                title: "Cancelar pedido",
                text: "Si continua perderá su cesta. ¿Desea continuar?",
                type: "confirm",
                showCancelButton: true,
                confirmButtonText: `Ok`,
                cancelButtonText: `Volver`,
                allowOutsideClick: false,
                reverseButtons: true
            }).then(r => {
                //console.log(r);
                if (r.dismiss == 'cancel'){

                } else if (r.value){
                    this.navigate(1);         
                    this.dialogPayment = false;
                }
            });
        },
        closeOKDialog(){
            this.navigate(1);
            this.dialogPayment = false;
        },
        checkPrice(item, last){
            this.priceChange = false;
            var auxthis = this;
            var url = this.ApiBaseUrlNETCore + "documents/detalleLinea/";
            var req = {};
            var price = 0;
            if (item.precioEditado)
                price = item.precio;            
            if (item.descuento == undefined)
                item.descuento = 0;

            if (this.$store.state.usuario.type == 'Cliente')  
                //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.usuario.custNo + '/' + item.no + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                req = { user:  this.$store.state.usuario.id,
                    guid: this.$store.state.usuario.userGUID,
                    custNo: this.$store.state.usuario.custNo,
                    itemNo: item.no,
                    uom: item.uom,
                    Qty: item.cantidad,
                    unitprice: price,
                    linedisc: item.descuento
                }
            else
                //url = this.ApiBaseUrl + '/pedidos/detalleLinea/' + this.$store.state.usuario.id + '/' + this.$store.state.usuario.userGUID + '/' + this.$store.state.customer.no + '/' + item.no + '/' + item.cantidad  + '/' + price + '/' + item.descuento;
                req = { user:  this.$store.state.usuario.id,
                    guid: this.$store.state.usuario.userGUID,
                    custNo: this.$store.state.customer.no,
                    itemNo: item.no,
                    uom: item.uom,
                    Qty: item.cantidad,
                    unitprice: price,
                    linedisc: item.descuento
                }
            this.axios.post(url, req,{headers: {"Content-Type": "application/json"}}) //API
            //this.axios.get(url)
            .then(response => {
                //console.log(response);
                if (response.status == 200){
                    var json = JSON.parse(response.data.res);
                    var precioNAV = parseFloat(json.unitprice.replace(',',''));
                    var descuentoNAV = parseFloat(json.linedisc);
                    if (item.precio != precioNAV){
                        item.precio = precioNAV;
                        auxthis.priceChange = true;
                    }
                    if (item.descuento != descuentoNAV){
                        item.descuento = descuentoNAV;
                        auxthis.priceChange = true;
                    }
                }
                //this.$store.commit('setOrderItem', item);                                   
            })
            .catch(function (error) {                
                // handle error
                //console.log(error);
            })
            .finally(function () {
                if (last && auxthis.priceChange){
                    auxthis.setGlobalDialog('💶 Cambio de precios','Algunos precios o descuentos han cambiado desde que creó su cesta. Compruebe los totales de nuevo', false);
                    auxthis.dialogPayment = false;
                } else if (last && !auxthis.priceChange){
                    auxthis.getiframe();
                }
                                                     
            });
        },
        checkCart(){
            this.getiframe();
            //Comentado el 10/02/23
            /*
            //check de precios primero
            var i = 1;
            this.listitems.forEach(item => {
                var last = (this.listitems.length == i);
                this.checkPrice(item, last);
                i++;
            });*/
        },
        getiframe(){
            document.getElementById("card-form").innerHTML = "";
            
            var fuc = '014395420';
            var terminal = '001';
            this.order = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 12);            
            getInSiteForm('card-form', '', '', '', '', 'Pagar con Redsys', fuc, terminal, this.order, 'ES');
            
            var card = document.getElementById("cardNumber");
            //console.log(card);
            this.card = true;
            this.cardClase = 'cardDiv';
            //this.dialogPaymentData.contenido = '';
        },
        initPago(){
            document.getElementById("card-form").innerHTML = "";
            var auxthis = this;
            var auxDoc = document;
            function merchantValidationEjemplo(){
                //console.log('asd');
                return true;
            }
            function pay(orderNo, amount, idOper) {     
                auxthis.$store.commit('setOneClick',auxthis.save);
                
                var url = "https://b2b.fiehisa.org/api/tpv/payment";
                
                auxthis.axios
                    
                    .post(url, {
                        custNo: auxthis.$store.state.usuario.custNo ,
                        idOper : idOper, 
                        orderNo : orderNo, 
                        navOrderNo: auxthis.dialogPaymentData.order, 
                        amount: amount,
                        save: auxthis.save,
                        user_guid: auxthis.$store.state.usuario.userGUID,
                        a: ''
                    },{headers: {"Content-Type": "application/json"}}) //API
                    .then(response => {    
                        if (response.data && !response.data.Ds_MerchantParameters && (response.data.responseType != 'auth2x') && ((response.data.substring(0,2) == 'ok') || (response.data.substring(0,2) == 'ko'))){
                            
                            auxthis.dialogPayment = false;
                            auxthis.card = false;
                            auxthis.cardClase = 'cardDivGone';
                            auxthis.$router.push({path: '/tpvAuth?res=' + response.data});
                        } else {
                            if (response.data.responseType == 'auth2x'){
                                auxthis.threeDSMethodData = response.data.data;
                                auxthis.auth2xurl = response.data.authurl;
                                var f = auxDoc.getElementById("auth2xForm");//.submit();
                                setTimeout(function(){ 
                                    f.submit(); 
                                }, 500);
                            } else {
                                var decodedParmsString = atob(response.data.Ds_MerchantParameters);
                                //console.log(decodedParmsString);
                                var decodedParmsJson = JSON.parse(decodedParmsString);
                                //console.log(decodedParmsJson);
                                auxthis.acsURL = decodedParmsJson.Ds_EMV3DS.acsURL;
                                if (decodedParmsJson.Ds_EMV3DS.MD && !decodedParmsJson.Ds_EMV3DS.creq) {
                                    auxthis.MD = decodedParmsJson.Ds_EMV3DS.MD;
                                    auxthis.PaReq = decodedParmsJson.Ds_EMV3DS.PAReq;
                                    
                                    var f = auxDoc.getElementById("authForm");//.submit();
                                    setTimeout(function(){ 
                                        f.submit(); 
                                    }, 500);
                                } else {
                                    auxthis.creq = decodedParmsJson.Ds_EMV3DS.creq;
                                    
                                    var f = auxDoc.getElementById("authForm2");//.submit();
                                    setTimeout(function(){ 
                                        f.submit(); 
                                    }, 500);
                                }
                            }
                        }
                    })
                    .catch(function (error) {   
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        auxthis.processing = false;
                    });
            }
            
            function receiveMessage(event) {
                //console.log(event);
                storeIdOper(event,"token", "errorCode", "merchantValidationEjemplo");
                if (event.data.idOper){
                    auxthis.processing = true;
                    pay(auxthis.order,auxthis.dialogPaymentData.total,event.data.idOper);
                }
            }
            //Listener de recepción de ID de operación
            window.addEventListener("message", receiveMessage);
        }
    },
    mounted(){  
        this.initPago();
        this.card = false;
        this.cardClase = 'cardDivGone';
        this.ok=false;
        this.save = true;
        this.processing = false;
    },
    computed: {     
        listitems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        dialogPayment:{
            get(){
                return this.$store.state.dialogPayment;
            },
            set(value){
                this.$store.state.dialogPayment = value;
            }
        }, 
        dialogPaymentData: {
            get(){
                return this.$store.state.dialogPaymentData;
            }
        }
    } 
}
</script>
<style scoped>
.title{
    font-size: 25px !important;
    color: #555555;
}
.dialogContent{
    font-size: 17px !important;
    color: #555555;
    font-weight: 400 !important;
}
.center{
    justify-content: center !important;
}
.cardDiv{
    height: 350px;
}
.cardDivGone{
    display: none;
}
.priceTag{
    font-size: large;
    font-weight: bolder;
}
</style>
